const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate jsonStringifyBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  if (!value) {
    return '';
  }

  // First, stringify with proper formatting
  const jsonString = JSON.stringify(value, null, 2);

  // Replace escaped newlines with actual newlines to respect formatting
  // This will make the output more readable when values contain newlines
  return jsonString.replace(/\\n/g, '\n');
};
module.exports = {
  evaluate
};